export const fileDownload = async (downloadResponse, defaultFileName) => {
    const blob = await downloadResponse.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;

    const contentDisposition = downloadResponse.headers.get('Content-Disposition');
    link.download = defaultFileName;

    if (contentDisposition) {
        const filenameMatch = contentDisposition.split('filename=')[1];
        if (filenameMatch) {
            link.download = filenameMatch.replace(/"/g, '');
        }
    }

    link.click();
    window.URL.revokeObjectURL(blobUrl);
};
